import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        path: "/insights",
        name: "insights",
        component: () => import("@/views/modules/insights/insights.vue"),
        meta: {
            contentClass: "module-insights",
            resource: "insights",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
];
